import { inject } from '@angular/core';
import type { Company } from '@indutrust/shared-model';
import { withCrudEntitiesEvents } from '@indutrust/shared-util';
import { signalStore } from '@ngrx/signals';
import { CompanyApiClient } from '../company-api-client.service';
import { companyEvents } from './company.events';

/**
 * Signal store for company state and retrieval.
 *
 * Provides CRUD operations for Company entities with event-driven architecture.
 * Handles company loading and management via {@link companyEvents}.
 *
 * API calls are automatically handled through the service factory passed to withCrudEntitiesEvents.
 *
 * @example
 * import { inject } from '@angular/core';
 * import { CompanyStore, companyEvents } from '@indutrust/company-data';
 * import { injectDispatch } from '@ngrx/signals/events';
 *
 * const store = inject(CompanyStore);
 * const dispatch = injectDispatch(companyEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const CompanyStore = signalStore(
  { providedIn: 'root' },
  withCrudEntitiesEvents<Company>(companyEvents, () => inject(CompanyApiClient))
);
